import { PALETTE_VARS } from "@styles/palette-vars";
import { Stack } from "@mui-wrapper";
import { useAppDispatch } from "@store/store-helper";
import { setBulkActionName, setInitialFetchingItems } from "@store/table/table-slice";
import { getSvgColoredIconCss } from "@utils/ui-utils";
import { Dialog, CheckmarkCircleFillIcon, Text } from "@flat-ui";
/** Show success message if all the bulk actions are successful */
export function BulkSuccessDialog({
  dialogContent,
  secondaryAction
}) {
  const dispatch = useAppDispatch();
  return <Dialog open={true} title={<Stack direction="row" sx={{
    alignItems: "center"
  }}>
          <CheckmarkCircleFillIcon sx={{
      ...getSvgColoredIconCss(PALETTE_VARS.success.main),
      height: "28px",
      width: "28px",
      mr: "12px"
    }} />
          {dialogContent.title}
        </Stack>} onConfirm={closeDialog} confirmText="Done" secondaryText={secondaryAction?.text} onSecondary={secondaryAction ? () => {
    closeDialog();
    secondaryAction.onClick();
  } : undefined}>
      <Text variant="bodyM">{dialogContent.description}</Text>
    </Dialog>;

  /** Ends the bulk action and clears the selection */
  function closeDialog() {
    dispatch(setBulkActionName(null));
    dispatch(setInitialFetchingItems([]));
  }
}